export const InputField = ({
  label,
  placeholder,
  icon: Icon,
  type = "text",
  value,
  onChange,
  name = "",
}) => (
  <div className="flex w-full flex-col gap-1.5">
    <label className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500">
      {label}
    </label>
    <div className="relative">
      {Icon && (
        <Icon
          className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          size={18}
        />
      )}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 ${
          Icon ? "pl-10" : ""
        } text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100`}
      />
    </div>
  </div>
);
